// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3YPYc","header":"style_header__2UuNS"};